<template>
    <div>
        <app-tabela
            :itens="analises"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="data" slot-scope="data">
                {{ data.data }}
            </template>
            <template slot="status" slot-scope="data">
                {{ data.status }}
            </template>
            <template slot="motivo" slot-scope="data">
                {{ data.motivo }}
            </template>
            <template slot="responsavelUabs" slot-scope="data">
                {{ data.responsavelUabs }}
            </template>
        </app-tabela>
    </div>
</template>

<script>
export default {
    name: 'RequisicaoAnalise',
    props: {
        requisicao: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            campos: [
                {
                    key: 'data',
                    label: 'Data',
                    type: 'date',
                    tdClass: 'text-nowrap text-left'
                },
                {
                    key: 'situacaoDescricao',
                    label: 'Status',
                    tdClass: 'text-nowrap text-left'
                },
                {
                    key: 'motivo',
                    label: 'Observação',
                    tdClass: 'text text-left'
                },
                {
                    key: 'responsavelUabs',
                    label: 'Responsável',
                    tdClass: 'text text-left'
                }
            ],
            itensPorPagina: 10,
            analises: []
        }
    },
    mounted() {
        if (this.requisicao) {
            this.analises = [...this.requisicao.historicoSolicitacao]
        }
    },
    watch: {
        requisicao() {
            if (this.requisicao) {
                this.analises = [...this.requisicao.historicoSolicitacao]
            }
        }
    }
}
</script>
